export enum PaymentCard3DsAuthorizationState {
    Authorizable = 'Authorizable',
    Authorized = 'Authorized',
    Unauthorizable = 'Unauthorizable',
}
